export default "__VITE_ASSET__Cvz9WRnx__"